import {styled} from "styled-components";
import {IonButton} from "@ionic/react";

export const IonRowButton = styled(IonButton).attrs({size: "small"})`
  font-size: 0.75rem;
`;
